import { Card, CardFooter, CardHeader } from "@fanduel/og-fe-library";
import { useCallback } from "react";
import Divider from "@/components/divider";
import NavigationLink from "@/components/navigationLink/NavigationLink";
import {
  SPORTSBOOK_URL,
  SPORTSBOOK_ODDS_CTA_CLICKED,
} from "@/constants/amplitude";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useArticleInfo } from "@/utils/hooks/useArticleContext";
import Styles from "./Skeleton.module.scss";

const coreMarkets = ["SPREAD", "MONEYLINE", "TOTAL"];

const Skeleton = () => {
  const { logAmplitudeEvent } = useAmplitude();
  const moreOddsUrl = SPORTSBOOK_URL;
  const { author, sport, title } = useArticleInfo();

  const onMoreOddsClick = useCallback(() => {
    logAmplitudeEvent(SPORTSBOOK_ODDS_CTA_CLICKED, {
      Sport: sport ?? "",
      Competition: "odds unavailable",
      "Article Title": title ?? "",
      Author: author ?? "",
      "Link Text": "more_odds_in_sportsbook",
      "Link URL": SPORTSBOOK_URL,
      Module: "coupon",
    });
  }, [author, logAmplitudeEvent, sport, title]);

  return (
    <Card className={Styles.card}>
      <CardHeader className={Styles.header}>
        <div className={Styles.labelContainer}>
          <div className={Styles.labels}>
            {coreMarkets.map((m) => (
              <span key={m}>{m}</span>
            ))}
          </div>
        </div>
      </CardHeader>
      <div className={Styles.cardContent}>
        <div className={Styles.teamsContainer}>
          <div className={Styles.teamPlaceholder} />
          <div className={Styles.separator}>
            <span>@</span>
            <Divider color="light" />
          </div>
          <div className={Styles.teamPlaceholder} />
        </div>
        <div className={Styles.betContainer}>
          <div className={Styles.betLinks}>
            {coreMarkets.map((m) => (
              <div key={m} className={Styles.oddsBtnPlaceholder} />
            ))}
          </div>
          <div className={Styles.betLinks}>
            {coreMarkets.map((m) => (
              <div key={m} className={Styles.oddsBtnPlaceholder} />
            ))}
          </div>
        </div>
      </div>
      <div className={Styles.moreOdds}>
        <NavigationLink
          href={moreOddsUrl}
          linkText="More odds in Sportsbook"
          onClick={onMoreOddsClick}
        />
      </div>
      <CardFooter className={Styles.footer}>
        <p>Odds/lines subject to change</p>
      </CardFooter>
    </Card>
  );
};

export default Skeleton;
